export const environment = {
  "version": "2.9.18",
  "revision": "c4e5e6a5",
  "production": true,
  "beta": false,
  "canary": false,
  "apiKey": "9415df8eff46408aa9c0d51e4d69b94f",
  "clientId": "37252",
  "client_secret": "KnVcJPWr7C5y0loOfBoKSyQ-vWXR0JICrgb1aJLsLgg",
  "offlineMode": false,
  "open_replay_project_key": "oWDBdT1yfziyDgHEGq61",
  "sentryDsn": "https://c2205d4589d43fc2a12cb7a05d56d3bc@o4510888602370048.ingest.us.sentry.io/4510888604205056",
  "showLogs": false,
  "featureFlags": {
    "enableModslotLimitation": true,
    "enableZeroWaste": true,
    "enableGuardianGamesFeatures": true
  }
};